let isExpanded = false;
document.addEventListener("DOMContentLoaded", function () {
    document.querySelector('.modal, body.template-product, body.template-index').addEventListener("click", function (event) {
        if (event.target.classList.contains("product-readmore")) {
            const buttonReadMore = document.querySelector('.product-readmore--read-full');
            const buttonReadLess = document.querySelector('.product-readmore--read-less');
            const shortDescription = document.querySelector('.product-description__short');
            const fullDescription = document.querySelector('.product-description__full');

            if (isExpanded) {
                // Collapsing: Show short description, hide full description
                if (shortDescription && fullDescription) {
                    shortDescription.lastElementChild.style.display = "contents";
                    fullDescription.style.display = "none";
                    buttonReadMore.style.display = "inline";
                    buttonReadLess.style.display = "none";
                }
            } else {
                // Expanding: Show full description, hide short description
                if (shortDescription && fullDescription) {
                    buttonReadMore.style.display = "none";
                    buttonReadLess.style.display = "block";
                    // Store the original short content before replacing it
                    if (!shortDescription.dataset.originalContent) {
                        shortDescription.lastElementChild.style.display = "contents";
                        fullDescription.style.display = "contents";
                    }
                }
            }
            isExpanded = !isExpanded;
        }
    });
});


jQuery(document).ready(function ($) {
    if ($('.announcement-bar-slider').length) {

        // Attach the 'init' event listener before initializing the slider
        $('.announcement-bar-slider').on('init', function () {
            // Show the slider once it's initialized
            $('.announcement-bar-slider').css('visibility', 'visible');
        });

        // Initialize the slick slider
        $('.announcement-bar-slider').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            dots: false,
            fade: false,
            infinite: true,
            draggable: false,
            swipe: false,
            // adaptiveHeight: true
        });
    }
});



